module.exports = __webpack_public_path__ + "img/eye.c8be6a30.svg";